export const CARS_TO_BUY_ROOT = 'cars-to-buy'

export const CARS_TO_BUY_CAR_DETAILS = 'car-details'

export const getCarsToBuyUrl = (partnerId, plate) => {
  const plateValue = plate ? `/${CARS_TO_BUY_CAR_DETAILS}/${plate}` : ''
  const partnerValue = partnerId ? `/${partnerId}` : ''

  return !partnerId
    ? `/${CARS_TO_BUY_ROOT}`
    : `/${CARS_TO_BUY_ROOT}${partnerValue}${plateValue}`
}
